// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1J_H2","col":"styles_col__2UeUc"};